import angular from 'angular';
import Utils from '~/scripts/services/utils';
import template from './tabs.html';
import fbtemplate from './builder/preview.html';

const tabsConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('tabs', {
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.component.active = 0;
			$scope.removeTab = (/** @type {number} */ index) => {
				$scope.component.tabs.splice(index, 1);
			};
			$scope.addTab = () => {
				$scope.component.tabs.push({ components: [], title: 'New tab', disabled: false });
			};
		},
		title:      'Tabs',
		template,
		fbtemplate,
		group:      'layout',
		children:   false,
		selectable: true,
		settings:   {
			action:    'event',
			active:    0,
			event:     null,
			label:     'Tabs',
			hideLabel: true,
			input:     false,
			tableView: false,
			key:       'tabs',
			tabs:      [
				{ components: [], title: 'New tab', disabled: false },
			],
		},
		icon:          'fa fa-clone',
		noDndOverlay:  true,
		confirmRemove: true,
		views:         [
			{
				name:     'Display',
				template: 'kform/components/tabs/display.html',
			},
			{
				name:     'API',
				template: 'templates/components/common/api2.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.uid = Utils.guid();
			if ($scope.form && $scope.form.getComponent) {
				const component = $scope.form.getComponent($scope.component.key);
				if (component.active === undefined) {
					$scope.component.active = 0;
					component.active = 0;
				}
				else {
					$scope.component.active = component.active;
				}
				$scope.select = (
					/** @type {Event} */ event,
					/** @type {number} */ index,
					/** @type {string} */ currentTab,
					/** @type {string} */ componentId,
				) => {
					$scope.$broadcast('Form.ktable-redraw', index, currentTab);
					event.preventDefault();
					$scope.component.active = index;
					component.active = index;

					// Ensure the componentId's match (even though they always should).
					if (componentId !== $scope.componentId) {
						return;
					}
					if ($scope.component.event) {
						$scope.$emit($scope.component.event, index, currentTab, $scope.data);
					}
				};
			}
			else {
				$scope.active = 0;
			}
		},
	});
};

export default angular.module('app').config(tabsConfig);
